import type { FaireProductEntity } from "../../entity_types/product";

export const p_13tgn8tetl: FaireProductEntity = {
  token: "p_13tgn8tetl",
  type: "product",
  name: "Organic Fruit Bites: Mango & Chili, 8-pack case",
  brandToken: "b_3suuhjvzxi",
  brandName: "Mavuno Harvest Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/1e060bf2f42275d208aa490b3c6fd49ce0088504977e80d1b19b423cc64d42f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6ebcfb609e953be61479a9e4bb0f17a5e6f51b307189f3d9e0508eb40be31a4.png",
    "https://cdn.faire.com/fastly/c84284b77eaa5c0fc6664f72eddf7fa34a078c87d894074aa2cdb7ca74f27e10.jpeg",
    "https://cdn.faire.com/fastly/84d259a411372795759da6fe4dfb6236384db44e325cb03a3c75b42d08bfb731.jpeg",
  ],
  priceDollars: 22.16,
  description:
    "Sweet with a Kick\n\n\n\nJuicy mango meets a hint of chili for a bold snack that’s both sweet and spicy. These chewy fruit bites are the perfect balance of tropical flavor and gentle heat.\n\n\n\nIngredients\n\n\n\n * Organic mango \n * Organic chili \n * No preservatives \n * No added sugar \nWhy It Matters\n\n\nOur mangoes are grown in Ghana by smallholder farmers, then paired with chili for a snack that’s adventurous, simple, and sustainable.\n",
  tags: [],
  msrpDollars: 37.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:30.271Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
